export default __webpack_public_path__ + "static/media/quiz.abcd566d.jpeg";